import * as React from 'react';

import Layer, {CloseableLayer} from './Layer';
import {Wash} from './Dialog';

type SharedProps = {
  canEscape?: boolean;
};

type OwnProps = {
  children: React.ReactNode;
  open: boolean;
  onClose?: () => void;
};

type Props = OwnProps & SharedProps;

export default class ModalLayer extends React.Component<Props> {
  static defaultProps = {
    canEscape: true,
  };

  handleClose = () => {
    if (!this.props.canEscape) {
      return;
    }
    this.props.onClose?.();
  };
  render() {
    const {children, open} = this.props;
    if (!open) {
      return null;
    }
    const inner = <Wash onClick={this.handleClose}>{children}</Wash>;
    if (this.props.canEscape) {
      return (
        <CloseableLayer onClose={this.handleClose}>{inner}</CloseableLayer>
      );
    }
    return <Layer>{inner}</Layer>;
  }
}

type OpenerProps = {
  children: (renderPropArgs: {handleOpen: () => void}) => JSX.Element;
  renderModal: (renderPropArgs: {handleClose: () => void}) => JSX.Element;
};

export const ModalOpener = ({
  children,
  renderModal,
  ...rest
}: OpenerProps & SharedProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpen = React.useCallback(() => setIsOpen(true), []);
  const handleClose = React.useCallback(() => setIsOpen(false), []);

  return (
    <>
      {children({handleOpen})}
      <ModalLayer {...rest} onClose={handleClose} open={isOpen}>
        {(isOpen && renderModal({handleClose})) || <div />}
      </ModalLayer>
    </>
  );
};
